import { measurementParts, formatMeasurement } from '../../utils/fraction';

/**
 * Render a measurement as a typographic fraction — 40¹⁄₂″ rather than "40 1/2".
 *
 * Built from <sup>/<sub> and a fraction slash instead of a unicode glyph (½):
 * the glyph is drawn from whatever font happens to resolve, and at the small
 * sizes used in tables it blurs when html2canvas rasterises the invoice to PDF.
 * Real markup keeps the numerator and denominator as text, so they stay sharp.
 */
export default function MeasurementValue({ value, inchMark = true, className = '', dash = '—' }) {
  const parts = measurementParts(value);
  if (!parts) return <span className={className}>{dash}</span>;

  const { whole, numerator, denominator } = parts;
  const mark = inchMark ? '″' : '';

  // No fractional part — render the plain number.
  if (numerator == null) {
    return <span className={`measurement-val ${className}`}>{whole}{mark}</span>;
  }

  return (
    <span className={`measurement-val ${className}`}>
      {/* A bare fraction reads as "½", not "0 ½". */}
      {whole !== 0 && whole}
      <span className="fraction">
        <sup>{numerator}</sup>&frasl;<sub>{denominator}</sub>
      </span>
      {mark}
    </span>
  );
}

/**
 * Plain-text variant for places that cannot take markup — CSV/Excel exports,
 * `title` attributes, WhatsApp messages. Uses the unicode glyph there, since
 * those destinations have no styling to work with.
 */
export const measurementText = (value, opts) => formatMeasurement(value, opts);
